const initialiseMiniBasket = () => {
  if (window.KabookiMiniBasket) return true

  const miniBasket = document.getElementById('js-mini-basket')
  const miniBasketBackdrop = document.getElementById('js-mini-basket-backdrop')

  if (miniBasket && miniBasketBackdrop) {
  const desktopBasketMedia = window.matchMedia('(min-width: 985px)')
  const navigation = document.querySelector('.js-navigation')
  const desktopBasketTrigger = document.querySelector('.navigation__basket.js-toggle-mini-basket')
  const desktopBasketCloseDelay = 300
  let desktopBasketCloseTimer

  const positionDesktopMiniBasket = () => {
    if (!desktopBasketMedia.matches || !desktopBasketTrigger) {
      miniBasket.style.removeProperty('--mini-basket-top')
      miniBasket.style.removeProperty('--mini-basket-right')
      return
    }

    const triggerRect = desktopBasketTrigger.getBoundingClientRect()
    // Mega menus start at the bottom of the complete navigation shell.
    const top = Math.round(navigation?.getBoundingClientRect().bottom ?? triggerRect.bottom + 10)
    const right = Math.max(16, Math.round(window.innerWidth - triggerRect.right))
    miniBasket.style.setProperty('--mini-basket-top', `${top}px`)
    miniBasket.style.setProperty('--mini-basket-right', `${right}px`)
  }

  const cancelDesktopBasketClose = () => {
    window.clearTimeout(desktopBasketCloseTimer)
  }

  const scheduleDesktopBasketClose = () => {
    if (!desktopBasketMedia.matches) return
    cancelDesktopBasketClose()
    desktopBasketCloseTimer = window.setTimeout(() => {
      setMiniBasketOpen(false)
    }, desktopBasketCloseDelay)
  }

  const cartNoticeLabels = () => {
    const language = (document.documentElement.lang || 'en').slice(0, 2)
    return {
      da: { added: 'Føjet til kurven', checkout: 'Gå til kassen', close: 'Luk', quantity: 'Antal', size: 'Størrelse', view: 'Se kurv' },
      de: { added: 'Zum Warenkorb hinzugefügt', checkout: 'Zur Kasse', close: 'Schließen', quantity: 'Anzahl', size: 'Größe', view: 'Warenkorb ansehen' },
      en: { added: 'Successfully added to cart', checkout: 'Checkout now', close: 'Close', quantity: 'Quantity', size: 'Size', view: 'View cart' },
    }[language] || { added: 'Successfully added to cart', checkout: 'Checkout now', close: 'Close', quantity: 'Quantity', size: 'Size', view: 'View cart' }
  }

  const parseBasketPage = (html) => new DOMParser().parseFromString(html, 'text/html')

  const findAddedBasketLine = (page, options = {}) => {
    const lines = Array.from(page.querySelectorAll('#js-mini-basket .mini-basket__product'))
    if (options.basketKey) {
      const matchingKey = lines.find((line) => line.dataset.basketKey === String(options.basketKey))
      if (matchingKey) return matchingKey
    }
    if (options.productId) {
      const matchingProduct = lines.find((line) => line.dataset.productId === String(options.productId))
      if (matchingProduct) return matchingProduct
    }
    return lines[lines.length - 1] || null
  }

  const createAddedContent = (html, options = {}) => {
    const labels = cartNoticeLabels()
    const content = document.createElement('div')
    content.className = 'cart-notice__content'
    content.setAttribute('role', 'status')

    const heading = document.createElement('div')
    heading.className = 'cart-notice__heading'
    heading.innerHTML = `
      <span class="cart-notice__check" aria-hidden="true">
        <svg><use xlink:href="/symbol/svg/sprite.symbol.svg#checkmark"></use></svg>
      </span>
      <strong>${options.message || labels.added}</strong>`
    content.append(heading)

    let addedLine = null
    if (html) {
      const sourceLine = findAddedBasketLine(parseBasketPage(html), options)
      if (sourceLine) {
        const line = sourceLine.cloneNode(true)
        line.classList.add('mini-basket__product--notice')
        const amountInput = line.querySelector('.add-to-basket__amount-input')
        const quantity = amountInput ? amountInput.value : '1'
        line.querySelector('.js-basket-actions')?.remove()

        const quantityText = document.createElement('div')
        quantityText.className = 'cart-notice__quantity'
        quantityText.textContent = `${labels.quantity}: ${quantity}`
        line.querySelector('.basket-page__price')?.before(quantityText)
        content.append(line)
        addedLine = line
      }
    }

    if (!addedLine && options.product) {
      const product = options.product
      const line = document.createElement('div')
      line.className = 'mini-basket__product mini-basket__product--notice productEntity'

      if (product.image) {
        const imageWrapper = document.createElement('div')
        imageWrapper.className = 'mini-basket__image-wrapper'
        const image = document.createElement('img')
        image.className = 'mini-basket__image'
        image.src = product.image
        image.alt = product.title || ''
        imageWrapper.append(image)
        line.append(imageWrapper)
      }

      const details = document.createElement('div')
      const title = document.createElement('div')
      title.className = 'basket-page__product-title'
      title.textContent = product.title || ''
      details.append(title)

      ;[product.colour, product.size ? `${labels.size}: ${product.size}` : ''].filter(Boolean).forEach((value) => {
        const attribute = document.createElement('div')
        attribute.className = 'basket-page__attribute-value basket-page__attribute-value--sm'
        attribute.textContent = value
        details.append(attribute)
      })

      const quantity = document.createElement('div')
      quantity.className = 'cart-notice__quantity'
      quantity.textContent = `${labels.quantity}: 1`
      details.append(quantity)

      if (product.price) {
        const price = document.createElement('div')
        price.className = 'basket-page__price'
        price.textContent = product.price
        details.append(price)
      }

      line.append(details)
      content.append(line)
    }

    const actions = document.createElement('div')
    actions.className = 'cart-notice__actions'
    actions.innerHTML = `
      <a href="/basket" class="cart-notice__checkout">${labels.checkout}</a>
      <a href="/basket" class="cart-notice__view">${labels.view}</a>`
    content.append(actions)
    return content
  }

  const closeCartNotice = () => {
    const notice = document.getElementById('js-cart-notice')
    if (!notice) return
    notice.classList.remove('cart-notice--open')
    notice.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('cart-notice-open')
  }

  const ensureCartNotice = () => {
    let notice = document.getElementById('js-cart-notice')
    if (notice) return notice

    const labels = cartNoticeLabels()
    notice = document.createElement('div')
    notice.id = 'js-cart-notice'
    notice.className = 'cart-notice'
    notice.setAttribute('aria-hidden', 'true')
    notice.innerHTML = `
      <button type="button" class="cart-notice__backdrop js-cart-notice-close" tabindex="-1" aria-label="${labels.close}"></button>
      <aside class="cart-notice__dialog" role="dialog" aria-modal="true" aria-label="${labels.added}">
        <button type="button" class="cart-notice__close js-cart-notice-close" aria-label="${labels.close}">
          <svg aria-hidden="true"><use xlink:href="/symbol/svg/sprite.symbol.svg#close"></use></svg>
        </button>
        <div class="cart-notice__body"></div>
      </aside>`
    document.body.append(notice)
    notice.addEventListener('click', (event) => {
      if (event.target.closest('.js-cart-notice-close')) closeCartNotice()
    })
    return notice
  }

  const showAddedNotice = (html, options = {}) => {
    const notice = ensureCartNotice()
    notice.querySelector('.cart-notice__body').replaceChildren(createAddedContent(html, options))
    notice.classList.toggle('cart-notice--wide', options.wide !== false)
    notice.classList.add('cart-notice--open')
    notice.setAttribute('aria-hidden', 'false')
    document.body.classList.add('cart-notice-open')
    document.dispatchEvent(new CustomEvent('kabooki:mobile-layer-open', { detail: { layer: 'cart-notice' } }))
    notice.querySelector('.cart-notice__close')?.focus()
  }

  const renderAddedNotice = (target, html, options = {}) => {
    if (!target) return false
    target.replaceChildren(createAddedContent(html, options))
    return true
  }

  const updateBasketCount = (page) => {
    const nextCount = page.querySelector('.navigation__basket-count')
    const currentCounts = document.querySelectorAll('.navigation__basket-count')

    if (nextCount && currentCounts.length) {
      currentCounts.forEach((currentCount) => {
        currentCount.textContent = nextCount.textContent
      })
    } else if (nextCount && !currentCounts.length) {
      document.querySelectorAll('.navigation__basket, .mobile-dock__basket').forEach((basketButton) => {
        basketButton.insertAdjacentElement(
          'afterbegin',
          nextCount.cloneNode(true)
        )
      })
    } else if (!nextCount && currentCounts.length) {
      currentCounts.forEach((currentCount) => currentCount.remove())
    }
  }

  const submitMiniBasketAmount = (input, amount) => {
    const basketForm = input.form
    if (!basketForm) return

    const previousAmount = input.value
    const nextAmount = Math.max(0, amount)
    const data = new URLSearchParams()
    const buttons = basketForm.querySelectorAll('.add-to-basket__amount-btn, .mini-basket__remove')
    data.append(input.name, nextAmount)
    input.value = nextAmount
    buttons.forEach((button) => { button.disabled = true })

    const options = {
      method: 'POST',
      credentials: 'same-origin',
      body: data,
    }
    // Production shops may still use the core without the optional tracking adapter.
    // Preserve their existing cart transport; never retry a failed adapter mutation.
    const mutation = window.KabookiNativeCart?.mutate
      ? window.KabookiNativeCart.mutate(basketForm.action, options, input.name)
      : fetch(basketForm.action, options).then((response) => {
        if (!response.ok) throw new Error('Basket update failed')
        return { confirmed: true }
      })
    mutation.then(({confirmed}) => {
        if (!confirmed) throw new Error('Basket update could not be confirmed')
        return fetch(
          `${window.location.pathname}${window.location.search}`,
          { credentials: 'same-origin' }
        )
      })
      .then((response) => {
        if (!response.ok) throw new Error('Basket refresh failed')
        return response.text()
      })
      .then((html) => {
        const page = new DOMParser().parseFromString(html, 'text/html')
        updateBasketCount(page)
        refreshMiniBasket(html, { open: true })
      })
      .catch((error) => {
        input.value = previousAmount
        console.error(error)
      })
      .finally(() => {
        buttons.forEach((button) => { button.disabled = false })
      })
  }

  const submitMiniBasketVoucher = (form) => {
    const button = form.querySelector('button[type="submit"]')
    const status = form.querySelector('.mini-basket__voucher-status')
    if (button) button.disabled = true
    if (status) status.textContent = ''

    fetch(form.action, {
      method: 'POST',
      credentials: 'same-origin',
      body: new FormData(form),
    })
      .then((response) => {
        if (!response.ok) throw new Error('Discount code update failed')
        return response.text()
      })
      .then((html) => {
        const page = parseBasketPage(html)
        updateBasketCount(page)
        refreshMiniBasket(html, { open: true })
      })
      .catch((error) => {
        if (status) status.textContent = error.message
        console.error(error)
      })
      .finally(() => {
        if (button?.isConnected) button.disabled = false
      })
  }

  const setMiniBasketOpen = (open) => {
    cancelDesktopBasketClose()
    if (open) positionDesktopMiniBasket()
    miniBasket.classList.toggle('mini-basket--active', open)
    miniBasketBackdrop.classList.toggle('mini-basket__backdrop--active', open)
    navigation?.classList.toggle('navigation--basket-open', open)
    miniBasket.setAttribute('aria-hidden', open ? 'false' : 'true')
    document.querySelectorAll('.js-toggle-mini-basket').forEach((trigger) => {
      trigger.classList.toggle('is-active', open)
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false')
    })
    window.KabookiSyncMobileLayerLock?.()

    if (open) {
      if (!desktopBasketMedia.matches) {
        window.requestAnimationFrame(() => {
          miniBasket.scrollTop = miniBasket.scrollHeight
        })
      }
      document.dispatchEvent(new CustomEvent('kabooki:mobile-layer-open', {
        detail: { layer: 'basket' },
      }))
    }
  }

  const toggleMiniBasket = () => {
    setMiniBasketOpen(!miniBasket.classList.contains('mini-basket--active'))
  }

  const refreshMiniBasket = (html, options = {}) => {
    const page = parseBasketPage(html)
    const nextMiniBasket = page.querySelector('#js-mini-basket')
    if (!nextMiniBasket) return false

    miniBasket.innerHTML = nextMiniBasket.innerHTML
    miniBasket.dataset.lineCount = nextMiniBasket.dataset.lineCount || '0'
    miniBasket.classList.toggle(
      'mini-basket--expanded',
      nextMiniBasket.classList.contains('mini-basket--expanded')
    )
    if (options.open) setMiniBasketOpen(true)
    document.dispatchEvent(new CustomEvent('kabooki:minibasket:updated'))
    return true
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.js-toggle-mini-basket')
    if (!trigger) return
    event.preventDefault()
    // Hover may already have opened the desktop panel before the click arrives.
    if (desktopBasketMedia.matches && trigger === desktopBasketTrigger) {
      cancelDesktopBasketClose()
      if (Number(miniBasket.dataset.lineCount) > 0) {
        window.location.assign('/basket')
        return
      }
      setMiniBasketOpen(true)
    } else {
      toggleMiniBasket()
    }
  })

  desktopBasketTrigger?.addEventListener('mouseenter', () => {
    if (!desktopBasketMedia.matches) return
    cancelDesktopBasketClose()
    setMiniBasketOpen(true)
  })
  desktopBasketTrigger?.addEventListener('mouseleave', scheduleDesktopBasketClose)
  miniBasket.addEventListener('mouseenter', cancelDesktopBasketClose)
  miniBasket.addEventListener('mouseleave', scheduleDesktopBasketClose)
  window.addEventListener('resize', positionDesktopMiniBasket)

  document.addEventListener('kabooki:mobile-layer-open', (event) => {
    if (event.detail?.layer !== 'basket') setMiniBasketOpen(false)
    if (event.detail?.layer !== 'cart-notice') closeCartNotice()
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCartNotice()
  })

  miniBasket.addEventListener('click', (event) => {
    const removeButton = event.target.closest('.mini-basket__remove')
    if (removeButton) {
      event.preventDefault()
      event.stopPropagation()
      const input = removeButton.closest('.js-basket-actions')?.querySelector('input')
      if (input && !removeButton.disabled) submitMiniBasketAmount(input, 0)
      return
    }
    const button = event.target.closest('.add-to-basket__amount-btn')
    if (!button) return
    event.preventDefault()
    event.stopPropagation()

    const basketAction = button.closest('.js-basket-actions')
    const input = basketAction && basketAction.querySelector('input')
    if (!input) return

    const currentAmount = parseInt(input.value, 10)
    if (Number.isNaN(currentAmount)) return

    if (button.classList.contains('productEntityDecreaseCart')) {
      submitMiniBasketAmount(input, currentAmount - 1)
    } else if (button.classList.contains('productEntityIncreaseCart')) {
      submitMiniBasketAmount(input, currentAmount + 1)
    }
  })

  miniBasket.addEventListener('change', (event) => {
    if (!event.target.matches('.js-basket-actions input')) return

    const amount = parseInt(event.target.value, 10)
    if (Number.isNaN(amount)) return
    submitMiniBasketAmount(event.target, amount)
  })

  miniBasket.addEventListener('submit', (event) => {
    const form = event.target.closest('.js-mini-basket-voucher')
    if (!form) return
    event.preventDefault()
    submitMiniBasketVoucher(form)
  })

  window.KabookiMiniBasket = {
    close: () => setMiniBasketOpen(false),
    open: () => setMiniBasketOpen(true),
    refresh: refreshMiniBasket,
    toggle: toggleMiniBasket,
  }

  window.KabookiCartNotice = {
    close: closeCartNotice,
    renderAdded: renderAddedNotice,
    showAdded: showAddedNotice,
  }

    if (window.location.hash === '#added') setMiniBasketOpen(true)
    return true
  }

  return false
}

if (!initialiseMiniBasket()) {
  const miniBasketObserver = new MutationObserver(() => {
    if (initialiseMiniBasket()) miniBasketObserver.disconnect()
  })

  miniBasketObserver.observe(document.documentElement, { childList: true, subtree: true })
  window.addEventListener('load', () => {
    if (initialiseMiniBasket()) miniBasketObserver.disconnect()
  }, { once: true })
}
